import { render, staticRenderFns } from "./ChatPageSingle.vue?vue&type=template&id=81313a94&"
import script from "./ChatPageSingle.vue?vue&type=script&lang=js&"
export * from "./ChatPageSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports